import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { RoleGate } from 'App/shared/RoleGate';
import { withAuth } from 'shared/AuthProvider';

export class RoleGatedRedirect extends React.Component {
	render() {
		return (
			<RoleGate
				allowedRoles={this.props.allowedRoles}
				auth={this.props.auth}
			>
				<Route
					exact={this.props.exact}
					path={this.props.from}
					render={() => <Redirect to={this.props.to} />}
				/>
			</RoleGate>
		);
	}
}

export default withAuth(RoleGatedRedirect);
